/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  preview(payload) {
    const url = `${this.url}/preview`;
    return axios.post(url, payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  recipients(id, params = {}) {
    return axios.get(`${this.url}/${id}/recipients`, { params });
  }

  export(id) {
    return axios.get(`${this.url}/${id}/export`, { responseType: 'blob' });
  }
}

export default new CampaignsAPI();
